import { CoursePathSegment } from '@/data/hook/course-line/useCoursesSegments';
import { MODULE_BASE, PED_CONTENT_BASE, UNIT_BASE, ROUTES } from './routes';
import { CoursesModelsType, CoursesNode } from './trees/TreeCourses';
import { isObjectUrl } from './project';
import { CreateCourseLine } from '@/data/services/courseLineServices';

export type DomainsNames = 'domain1' | 'domain2';
type Domain = {
  name: DomainsNames;
  models: Set<CoursesModelsType>;
};

const domains: Domain[] = [
  {
    name: 'domain1',
    models: new Set(['courseLine', 'module']),
  },
  {
    name: 'domain2',
    models: new Set(['course', 'unit', 'lesson']),
  },
];

export function getDomainFromType(type: CoursesModelsType) {
  for (const domain of domains) {
    if (domain.models.has(type)) {
      return domain.name;
    }
  }
}

export const buildHrefCourseLineByTreePath = (path: CoursesNode[]) => {
  const base = ROUTES.ADMIN.COURSE_LINES.BASE;
  const courseLineId = path.find(node => node.type === 'courseLine')?.realId;
  if (!courseLineId) {
    return base;
  }

  return `${base}/${courseLineId}`;
};

export const buildHrefCourseModuleByTreePath = (path: CoursesNode[]) => {
  const base = buildHrefCourseLineByTreePath(path);
  const courseModuleId = path.find(node => node.type === 'module')?.realId;
  if (!courseModuleId) {
    return base;
  }
  return `${base}${MODULE_BASE}/${courseModuleId}`;
};

export const buildHrefCourseByTreePath = (path: CoursesNode[]) => {
  const base = buildHrefCourseModuleByTreePath(path);
  const courseId = path.find(node => node.type === 'course')?.realId;
  if (!courseId) return base;
  return `${base}${PED_CONTENT_BASE}/${courseId}`;
};

export const buildHrefUnitByTreePath = (path: CoursesNode[]) => {
  const base = buildHrefCourseByTreePath(path);
  const unitId = path.find(node => node.type === 'unit')?.realId;
  if (!unitId) return base;
  return `${base}${UNIT_BASE}/${unitId}`;
};

export const LESSON_BASE = '/lesson';

export const buildHrefLessonByTreePath = (path: CoursesNode[]) => {
  const base = buildHrefUnitByTreePath(path);
  const lessonId = path.find(node => node.type === 'lesson')?.realId;
  if (!lessonId) return base;
  return `${base}${LESSON_BASE}/${lessonId}`;
};

export const mountKey = ({
  type,
  id,
}: Pick<CoursePathSegment, 'type' | 'id'>) => {
  return `${type}-${id}`;
};

export const generateBannerPayload = async (
  bannerUrl?: string,
): Promise<Pick<CreateCourseLine, 'bannerImg'>> => {
  if (bannerUrl && isObjectUrl(bannerUrl)) {
    const blob = await fetch(bannerUrl).then(r => r.blob());
    const file = new File([blob], 'banner.jpg', { type: blob.type });
    return { bannerImg: file };
  }
  return { bannerImg: bannerUrl };
};
